import React, { forwardRef, useImperativeHandle } from 'react';

import { SubForm } from '@/_components';

import { type Props, useUpdateNumber } from './use-update-number';

import { FormFields } from '../../shared';
import { PhoneNumberControls } from '../controls';
import { usePreviewNumber } from '../preview/use-preview';
import type { AddPhoneNumberRef } from '../preview/use-preview';
import type { PhoneNumberRef } from '../types';

function UpdatePhoneNumberBase(props: Props, ref: React.Ref<PhoneNumberRef>) {
  const { isEditable } = props;

  const { id, form, onSubmit, isPending, countries, defaultCountryValue, onValidateDuplicate } = useUpdateNumber(props);
  const { onDelete } = usePreviewNumber(props);

  const [number] = form.watch(['number']);

  useImperativeHandle(ref, () => {
    const refValue: AddPhoneNumberRef = {
      number,
      validate: async () => {
        const result = await form.trigger();
        return result;
      },
    };
    return refValue;
  });

  return (
    <SubForm id={`update-phone-number-${id}`} {...form} onSubmit={onSubmit} isSubmitting={isPending}>
      <FormFields
        form={form}
        countries={countries}
        defaultCountryValue={defaultCountryValue}
        isEditable={isEditable}
        id={id}
        onValidateDuplicate={onValidateDuplicate}
      >
        <PhoneNumberControls onDelete={onDelete} isEditing={isEditable} />
      </FormFields>
    </SubForm>
  );
}

const UpdatePhoneNumber = React.memo(forwardRef<PhoneNumberRef, Props>(UpdatePhoneNumberBase));

export { UpdatePhoneNumber };
